<template>
    <div class="sn-sidebar-content">
        <ul>
            <li>
                <router-link to="/dashboard" :class="{'active': getRoute().includes('dashboard')}">
                    <i class="fas fa-tachometer-alt fa-fw"></i>&nbsp;&nbsp;Bacheca
                </router-link>
            </li>
            <li>
                <router-link to="/anagrafica-clienti" :class="{'active': getRoute().includes('anagrafica-clienti')}">
                    <i class="fas fa-industry fa-fw"></i>&nbsp;&nbsp;Anagrafica Clienti
                </router-link>
            </li>
            <li>
                <router-link to="/catalogo" :class="{'active': getRoute().includes('catalogo')}">
                    <i class="fas fa-shopping-cart fa-fw"></i>&nbsp;&nbsp;Catalogo Corsi
                </router-link>
            </li>
            <li>
                <router-link to="/corsi" :class="{'active': getRoute().includes('corsi')}">
                    <i class="fas fa-chalkboard-teacher fa-fw"></i>&nbsp;&nbsp;Corsi
                </router-link>
            </li>
            <li>
                <router-link to="/docenti" :class="{'active': getRoute().includes('docenti')}">
                    <i class="fas fa-graduation-cap fa-fw"></i>&nbsp;&nbsp;Docenti
                </router-link>
            </li>
            <li>
                <router-link to="/questionari" :class="{'active': getRoute().includes('questionari')}">
                    <i class="fas fa-question-circle fa-fw"></i>&nbsp;&nbsp;Questionari
                </router-link>
            </li>
            <!-- <li>
                <router-link to="/risultati" :class="{'active': getRoute().includes('risultati')}">
                    <i class="fas fa-check-double fa-fw"></i>&nbsp;&nbsp;Risultati
                </router-link>
            </li> -->
            <li>
                <router-link to="/operatori" :class="{'active': getRoute().includes('operatori')}">
                    <i class="fas fa-hard-hat fa-fw"></i>&nbsp;&nbsp;Operatori
                </router-link>
            </li>
            <li>
                <router-link to="/impostazioni" :class="{'active': getRoute().includes('impostazioni')}">
                    <i class="fas fa-cog fa-fw"></i>&nbsp;&nbsp;Impostazioni
                </router-link>
            </li>
            <li><a href="#" @click="DoLogout"><i class="fas fa-sign-out-alt fa-fw"></i>&nbsp;&nbsp;Logout</a></li>
            

        </ul>

        <div class="sn-sidebar-user">
            Utente: {{ nomeCognome }}<br />
            Ultimo accesso: {{ lastLogin }}<br />
            <router-link to="/profilo-utente" :class="{'active': getRoute().includes('profilo-utente')}">
                    <i class="fas fa-user-cog fa-fw"></i>&nbsp;&nbsp;Impostazioni utente
            </router-link><br />
            <small>Versione: 1.1</small>
        </div>
    </div>
</template>

<script>

export default {
  name: "SidebarElement",
  inject: ['cfg'],
  props: {
  
  },
  data() {
    return {
        nomeCognome: "--",
        lastLogin: "--",
    };
  },
  components: {
    
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    DoLogout() {
      if(confirm('Vuoi scollegarti?')) {
        this.$store.commit('Messaggio', {parms: [true, ['Logout in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});

        fetch(this.cfg.apisrv + "/api/User/DoLogout?token=" + this.$store.state.UserInfo.token + "&resetPwd=false" )
        .then(response => response.json())
        .then(obj => {
            this.$store.commit('Messaggio', {parms: [true, ['Fatto.'], 'alert alert-success', 'fa-check', true, 1000]});

            this.$store.commit('UserInfo',{ token: "" });
            this.$router.push("/");  
        });


      }
      

    },
  },
  mounted: function() {
    this.nomeCognome = this.$store.state.UserInfo.ute_cognome + " " + this.$store.state.UserInfo.ute_nome;
    this.lastLogin = this.$store.state.UserInfo.ute_ultimoAccesso;

  }
};
</script>

<style scoped>
.sn-sidebar-content {
    background-color: #333;
    color: #fff;
    height: 100vh;
    padding: 10px 10px 10px 10px;
}

.sn-sidebar-content ul {
    list-style-type: none;
    padding: 0;
}

.sn-sidebar-content ul li {
    padding: 10px 20px;
}

.sn-sidebar-content ul li a {
    color: white;
    text-decoration: none;
    display: block;
    border-bottom: 1px solid #444;
    transition: background-color 0.3s ease;
}

.sn-sidebar-content ul li a.active {
    color: #CC3731;
}

.sn-sidebar-content ul li a:hover {
    background-color: #444;
}

/* Sezione utente */

.sn-sidebar-user {
    position: absolute; 
    bottom: 0;
    padding-bottom:10px;
    font-size: 0.8rem;
    border-top:solid 1px #444;
    padding-top:10px;
    padding-left:5px;
}
.sn-sidebar-user a {
    color:antiquewhite;
    text-decoration: none;
}
.sn-sidebar-user a:hover {
    background-color:#444;
}
</style>